import { useCurrentUser } from './useCurrentUser';

export const useClientSubDomain = (): string => {
  const user = useCurrentUser();
  return user?.client_config?.sub_domain;
};
